import { render, staticRenderFns } from "./FirstComp.vue?vue&type=template&id=4331d794&scoped=true&"
import script from "./FirstComp.vue?vue&type=script&lang=js&"
export * from "./FirstComp.vue?vue&type=script&lang=js&"
import style0 from "./FirstComp.vue?vue&type=style&index=0&id=4331d794&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4331d794",
  null
  
)

export default component.exports